import React from "react";
import PrivateRoute from "PrivateRoutes";
import { withRouter, Redirect } from "react-router";
const REPORT = React.lazy(()=> import(/* webpackChunkName: "CommonAgentReports" */'./components'));

const commonReportsObject = {
	"team-summary": {
		moduleUrl: "/reporting/agent/team-summary",
		dataUrl: "user/agent/team/report",
		downloadFileUrl: "user/export/agent/team/report",
		moduleName: "Team Summary",
	},
	"campaign-summary": {
		moduleUrl: "/reporting/agent/campaign-summary",
		dataUrl: "user/agent/campaign/report",
		downloadFileUrl: "user/export/agent/campaign/report",
		moduleName: "Campaign Summary",
	},
	"auto-dispose-summary": {
		moduleUrl: "/reporting/agent/auto-dispose-summary",
		dataUrl: "user/agent/autoDispose/report",
		downloadFileUrl: "user/export/agent/autoDispose/report",
		moduleName: "Auto Dispose Summary",
	},
	"agent-heat-map": {
		moduleUrl: "/reporting/agent/agent-heat-map",
		dataUrl: "user/agent/agent-heat-map/report",
		downloadFileUrl: "agent-heat-map/export/report",
		moduleName: "Agent Heat Map",
	},
	"lead-status": {
		moduleUrl: "/reporting/lead/lead-status",
		dataUrl: "user/agent/leadStatus/report",
		downloadFileUrl: "user/export/agent/leadStatus/report",
		moduleName: "Lead Status",
	},
	"contact-list-call-statistics": {
		moduleUrl: "/reporting/lead/contact-list-call-statistics",
		dataUrl: "user/agent/contact-list-call-statistics/report",
		downloadFileUrl: "user/export/agent/contact-list-call-statistics/report",
		moduleName: "Contact List Call Statistics",
	},
	"duplicate-lead-identification-report": {
		moduleUrl: "/reporting/lead/duplicate-lead-identification-report",
		dataUrl: "user/agent/duplicateLead/report",
		downloadFileUrl: "user/export/agent/duplicateLead/report",
		moduleName: "Duplicate Lead Identification Report",
	},
};

const CommonAgentReports = ({ match }) => {
	let key = match.params.type;
	if (key in commonReportsObject) {
		let dataUrl =
			commonReportsObject[match.params.type] &&
			commonReportsObject[match.params.type].dataUrl;
		let downloadFileUrl =
			commonReportsObject[match.params.type] &&
			commonReportsObject[match.params.type].downloadFileUrl;
		let moduleName =
			commonReportsObject[match.params.type] &&
			commonReportsObject[match.params.type].moduleName;
		let moduleUrl =
			commonReportsObject[match.params.type] &&
			commonReportsObject[match.params.type].moduleUrl;
		return (
			<REPORT
				key={key}
				dataUrl={dataUrl}
				downloadFileUrl={downloadFileUrl}
				moduleName={moduleName}
				moduleUrl={moduleUrl}
			/>
		);
	}
	return <Redirect to="/not-found" />;
};

const routes = () => (
	<React.Fragment>
		<PrivateRoute
			key={"/reporting/agent"}
			exact={true}
			path="/reporting/agent/:type"
			component={CommonAgentReports}
		/>
		<PrivateRoute
			key={"/reporting/lead"}
			exact={true}
			path="/reporting/lead/:type"
			component={CommonAgentReports}
		/>
	</React.Fragment>
);

export default withRouter(routes);



// WEBPACK FOOTER //
// src/modules/screens/reporting/CommonAgentReports/routes.js